module.exports = __webpack_public_path__ + "img/los-cocos-img-bg.730894d8.png";